/**
 * SmsConsent · v2.7.65+E165
 * ─────────────────────────────────────────────────────────────────────────
 * TCPA-style SMS consent checkbox + disclosure block for every public
 * Buller Taxi form that collects a phone number.
 *
 * Usage
 * ─────
 *   const [smsConsent, setSmsConsent] = useState(false);
 *
 *   <SmsConsent value={smsConsent} onChange={setSmsConsent} testIdPrefix="qb" />
 *
 *   // Submit payload:
 *   { ..., sms_consent: smsConsent, sms_consent_ts: new Date().toISOString() }
 *
 * Spec fixed by legal — text must be verbatim, do NOT reword.
 */
import { Link } from "react-router-dom";

export default function SmsConsent({
  value = false,
  onChange,
  testIdPrefix = "sms-consent",
  required = false,   // set true if the form REQUIRES opt-in before submit
  className = "",
}) {
  return (
    <div
      className={`text-[11px] leading-relaxed text-zinc-400 space-y-2 ${className}`}
      data-testid={`${testIdPrefix}-block`}
    >
      <label className="flex items-start gap-2 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange?.(e.target.checked)}
          required={required}
          data-testid={`${testIdPrefix}-checkbox`}
          className="mt-0.5 h-3.5 w-3.5 accent-amber-400 flex-shrink-0"
        />
        <span className="text-zinc-300">
          I agree to receive SMS text messages from Buller Taxi Services, LLC
          for booking updates, dispatch notifications, and customer service.
        </span>
      </label>
      <p className="text-[10px] leading-relaxed text-zinc-500" data-testid={`${testIdPrefix}-disclosure`}>
        By providing your phone number and clicking submit, you consent to receive
        text messages from Buller Taxi Services, LLC regarding your ride requests
        and service updates. Message frequency varies. Message and data rates may
        apply. Reply STOP to unsubscribe or HELP for assistance. View our{" "}
        <Link to="/legal/privacy" className="text-amber-400 hover:underline" data-testid={`${testIdPrefix}-privacy-link`}>
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link to="/legal/terms" className="text-amber-400 hover:underline" data-testid={`${testIdPrefix}-terms-link`}>
          Terms of Service
        </Link>
        .
      </p>
    </div>
  );
}
